export default {"src":"/_next/static/media/payment-mastercard.71a86f45.svg","height":30,"width":44,"blurWidth":0,"blurHeight":0};